'use strict';

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function () {

	/**
	 * Static constant for aggregation types to be pushed to server to get summary values
	 */
	const SUMMARY_TYPES = [
		'none',
		'countdistinct',
		'avg',
		'calculated',
		'automatic'
	];

	return SUMMARY_TYPES;
});
